import { render, staticRenderFns } from "./cmpbreadcrumb.vue?vue&type=template&id=203cbd9b&"
import script from "./cmpbreadcrumb.vue?vue&type=script&lang=js&"
export * from "./cmpbreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports